import { useQuery } from '@tanstack/react-query';
import type { AgentApiInvitationsShow } from '@/types/serializers';

export default function useFetchInvitationsInfo(token: string) {
  return useQuery({
    queryKey: ['invitationsInfo', token],
    queryFn: async () => {
      const response = await fetch(`/account/api/invitations/${token}`);
      if (!response.ok) {
        throw new Error('Failed to fetch invitation info');
      }
      const data: AgentApiInvitationsShow = await response.json();
      return data;
    },
    enabled: !!token, // トークンがある場合のみクエリを実行
  });
}
